import React from 'react';
import { useTranslation } from 'src/hooks/useTranslation';
import { FieldLabelContainer } from './FieldLabel.styles';

export interface FieldLabelProps {
  label: string;
  required?: boolean;
  id?: string;
}

const FieldLabel = ({ label, required, id }: FieldLabelProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <FieldLabelContainer id={id}>
      {t(label)}
      {required && <span>*</span>}
    </FieldLabelContainer>
  );
};

export default FieldLabel;
